import { Provider } from '@ethersproject/providers';
import { Crucible } from 'types';
import { ethers } from 'ethers';
import { crucibleFactoryAbi } from 'abi/crucibleFactoryAbi';
import {
  getCrucibleIdsFromEvents,
  getCrucibleMembership,
  getSingleCrucibleEntities
} from 'utils/crucible';

export async function getSingleCrucible(
  crucibleAddress: string,
  customMinterAddress: string,
  crucibleSubgraphUrl: string,
  transmuterAddress: string,
  mintingTokenAddress: string,
  crucibleFactoryAddress: string,
  crucibleFactoryCreationBlock: number,
  provider: Provider,
  customFetcher?: any
): Promise<Crucible | undefined> {
  const { chainId } = await provider.getNetwork();

  const crucibleFactory = new ethers.Contract(
    crucibleFactoryAddress,
    crucibleFactoryAbi,
    provider
  );

  const isInstance = await crucibleFactory.isInstance(crucibleAddress);

  if (!isInstance) {
    throw Error('Not a crucible address');
  }

  // if (chainId === 1) {
  //   const crucibleFactory = new ethers.Contract(
  //     crucibleFactoryAddress,
  //     crucibleFactoryAbi,
  //     provider
  //   );

  //   const owner = await crucibleFactory.ownerOf(crucibleAddress);
  //   const filter = crucibleFactory.filters.Transfer(
  //     '0x0000000000000000000000000000000000000000',
  //     null,
  //     crucibleAddress
  //   );
  //   const crucibleEvents = await crucibleFactory.queryFilter(
  //     filter,
  //     0,
  //     'latest'
  //   );
  //   const ids = getCrucibleIdsFromEvents(crucibleEvents);

  //   const crucibles = await Promise.all(
  //     ids.map(async ({ id, event }) => {
  //       const block = await provider.getBlock(event.blockNumber);

  //       const membership = await getCrucibleMembership(
  //         id,
  //         customMinterAddress,
  //         transmuterAddress,
  //         mintingTokenAddress,
  //         crucibleFactory,
  //         crucibleFactoryCreationBlock,
  //         provider
  //       );
  //       return {
  //         id,
  //         owner,
  //         mintTimestamp: block.timestamp,
  //         mintBlockNumber: event.blockNumber,
  //         membership
  //       } as Crucible;
  //     })
  //   );
  //   const filteredCrucible = crucibles.find(
  //     (crucible) => crucible.id.toLowerCase() === crucibleAddress.toLowerCase()
  //   );
  //   return filteredCrucible;
  // } else {
  const crucibleEntities = await getSingleCrucibleEntities(
    crucibleAddress.toLowerCase(),
    crucibleSubgraphUrl,
    customFetcher
  );

  const crucibles = await Promise.all(
    crucibleEntities.map(async ({ id, timestamp, owner, blockNumber }) => {
      const crucibleFactory = new ethers.Contract(
        crucibleFactoryAddress,
        crucibleFactoryAbi,
        provider
      );

      const membership = await getCrucibleMembership(
        id,
        customMinterAddress,
        transmuterAddress,
        mintingTokenAddress,
        crucibleFactory,
        crucibleFactoryCreationBlock,
        provider,
        blockNumber
      );

      return {
        id,
        owner,
        mintTimestamp: Number(timestamp),
        mintBlockNumber: blockNumber,
        membership
      } as Crucible;
    })
  );

  const filteredCrucible = crucibles.find(
    (crucible) => crucible.id.toLowerCase() === crucibleAddress.toLowerCase()
  );

  return filteredCrucible;
  // }
}
